// eslint-disable-next-line vue/multi-word-component-names
<template>
  <el-footer
    height="auto"
    class="c-footer"
  >
    <div
      class="foot-con margin-center"
      v-if="!(siteInfo?siteInfo.configuration?.showFooterNav:'')"
    >
      <!-- <div class="foot-nav">
        <div class="foot-nav-top-title">
          <span class="main-title">咨询行业专业顾问</span>
          <span class="sub-title">关于酷开解决方案的更多咨询，请联系我们的销售和技术团队。</span>
        </div>
        <span
          class="foot-nav-btn"
          @click="openConsult"
        >
          <img
            :src="require('@/assets/images/footer-question.png')"
            alt="咨询"
          />
          立即咨询
        </span>
      </div>
      <div class="footer-card">
        <img :src="require('@/assets/images/footer-card.png')" />
      </div> -->
      <div class="contact">
        <div>
          <img
            :src="require('@/assets/images/footer-logo.png')"
            :style="{'height':'25px'}"
          />
          <div class="socialize">
            <div v-for="(item, index) in socialize" :key="index" class="socialize-item" @click="openNavLink(item.link)">
              <coocaa-popover
                placement="top-start"
                width="150"
                trigger="hover"
                :disabled="!item.image"
              >
                <coocaa-image :src="item.image" v-if="item.image" style="width: 150px; height: 150px;"></coocaa-image>
                <coocaa-image slot="reference" :src="item.icon" :alt="item.name"></coocaa-image>
              </coocaa-popover>
            </div>
          </div>
        </div>
        <ul
          class="contact-uls"
          v-for="(item, index) of navList"
          :key="index"
        >
          <li class="contact-li-main-title contact-li-nocursor">{{ item.label }}</li>
          <li
            v-for="(child, cIndex) of item.children"
            :key="cIndex"
            :class="['contact-uls-li', { 'contact-li-nocursor': !child.link }]"
            @click="child.link && openNavLink(child.link)"
          >
            {{ child.label }}
          </li>
        </ul>
      </div>
    </div>
    <div class="copyright">
      <div>{{copyrightInfo.name}}<a
          href="http://beian.miit.gov.cn/"
          target="_blank"
        >{{copyrightInfo.no}}</a>
        <a
          v-if="copyrightInfo.beianNo"
          :href="`https://beian.mps.gov.cn/#/query/webSearch?code=${copyrightInfo.beianNo}`"
          target="_blank"
        > 粤公网安备 {{copyrightInfo.beianNo}}号</a>
        |
        <a :href="legalNoticeUrl">法律声明</a>
        <a style="margin-left: 5px;" :href="privacyAgreementUrl">隐私政策</a>
      </div>
    </div>
  </el-footer>
</template>

<script>
import { CONTACT_PHONE } from '@/utils/constants'
import { getCopyrightInfo } from '@/utils/common'
export default {
  props: ['siteInfo'],
  data () {
    return {
      socialize: [
        {
          icon: 'https://v-play.coocaa.com/cfg/SaaS_products/dev_static_img/592cf4a6-9809-4f9a-877a-8fdf8f5a57ed.png',
          name: '微博',
          link: 'https://weibo.com/u/7984067031',
          image: ''
        },
        {
          icon: 'https://v-play.coocaa.com/cfg/SaaS_products/dev_static_img/37088b6c-160c-4306-848f-88fc7590442c.png',
          name: '微信',
          link: '',
          image: 'https://v-play.coocaa.com/cfg/SaaS_products/dev_static_img/7f26ad4c-3e6e-4dc6-9f64-a124e5aa67d8.jpg'
        },
        {
          icon: 'https://v-play.coocaa.com/cfg/SaaS_products/dev_static_img/0063e96b-c7f9-47c9-93ee-a33c2f114b7b.png',
          name: '抖音',
          link: '',
          image: 'https://v-play.coocaa.com/cfg/SaaS_products/dev_static_img/9eca4178-dc62-462d-8d26-edd801ef5b0f.jpg'
        },
        {
          icon: 'https://v-play.coocaa.com/cfg/SaaS_products/dev_static_img/573a0d07-3ad6-426a-aae3-c1e740bb759b.png',
          name: '小红书',
          link: '',
          image: 'https://v-play.coocaa.com/cfg/SaaS_products/dev_static_img/16b52cc4-c366-4491-aaa4-eb3d3c1321ce.jpg'
        }
      ],
      navList: [
        {
          label: '酷开科技',
          link: '',
          children: [
            { label: '公司介绍', link: '/page/1933069059868327936' },
            { label: '酷开AI', link: '/ai-experience' },
            { label: 'Coolita', link: '/product/coocaa/1910625733902860288' }
          ]
        },
        {
          label: '生态伙伴',
          link: '',
          children: [
            { label: '创维', link: 'http://www.skyworth.com/', className: 'contact-uls-li' },
            { label: '飞利浦', link: 'https://www.philips.com.cn/', className: 'contact-uls-li' },
            { label: '小福家', link: 'https://xiaofujia.com/', className: 'contact-uls-li' },
            { label: 'Miitee', link: 'https://www.miitee.com/', className: 'contact-uls-li' }
          ]
        },
        {
          label: '联系我们',
          link: '',
          children: [
            { label: `客户服务与投诉热线：${CONTACT_PHONE}`, link: '' },
            { label: '商务合作：bdc@coocaa.com', link: '' },
            { label: '人才招聘：zhaopin@coocaa.com', link: '' }
          ]
        }
      ],
      copyrightInfo: getCopyrightInfo(),
      legalNoticeUrl: process.env.VUE_APP_LEGALNOTICE,
      privacyAgreementUrl: process.env.VUE_APP_PRIVACYAGREEM
    }
  },
  methods: {
    openConsult () {
      window.open(this.$router.resolve({ name: 'consultFormPage' }).href, '_blank')
    },
    openNavLink (link) {
      if (link) {
        window.open(link, '_blank')
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.c-footer {
  background: #000;
  padding: 0;
}

.foot-con {
  padding: 73px 10px 10px 10px;
  box-sizing: border-box;
  position: relative;
  max-width: 1208px;

  .footer-card {
    position: absolute;
    top: -30px;
    right: 0;
  }

  .foot-nav {
    max-width: 642px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-bottom: 117px;

    .foot-nav-top-title {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;

      .main-title {
        font-size: 20px;
        line-height: 30px;
        font-weight: 500;
        color: #fff;
      }

      .sub-title {
        font-size: 16px;
        line-height: 28px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.8);
        margin-top: 2px;
      }
    }

    .foot-nav-btn {
      color: #fff;
      background: rgba(21, 94, 255, 1);
      padding: 9px 20px;
      border-radius: 4px;
      box-shadow: 6px 9px 40px 0 rgba(63, 60, 255, 0.44);
      font-size: 14px;
      cursor: pointer;

      img {
        vertical-align: bottom;
      }
    }
  }

  .contact {
    max-width: 1208px;
    margin-bottom: 48px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .contact-uls {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;

      .contact-uls-li, .contact-li-nocursor {
        color: rgba(255, 255, 255, 0.6);
        cursor: pointer;
        margin-bottom: 24px;

        &:first-child {
          color: #fff;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
      .contact-uls-li:not(.contact-li-nocursor):hover{
        color #fff
      }

      .contact-li-nocursor {
        cursor: default
      }
    }
  }
}

.copyright {
  line-height: 22px;
  padding: 32px 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  align-items: center;
  display: flex;
  justify-content: center;
  border-top: 1px solid rgba(255, 255, 255, 0.1);

  .foot-logo {
    display: inline-block;
    margin-right: 20px;
  }

  a {
    color: rgba(255, 255, 255, 0.6);
    text-decoration: none;
    cursor: pointer;

    &:hover {
      color: #fff;
    }
  }
}

@media screen and (max-width: $mobile-width) {
  .c-footer {
    min-width: 280px;
  }

  .foot-con {
    padding: 14px 0;
    width: 100%;
    flex-wrap: wrap;
    min-width: 280px;
    font-size: 12px;

    .foot-nav {
      display: none;
    }

    .footer-card {
      display: none;
    }

    .contact {
      width: 100%;
      padding: 0 14px;
      box-sizing: border-box;
      margin-bottom: 0;
      flex-direction: column;

      .contact-uls {
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
        padding-top: 10px;

        &:first-of-type {
          padding-top: 20px;
        }

        .contact-li-nocursor {
          width: 100%;
        }

        .contact-li-main-title {
          font-size: 14px;
        }

        .contact-uls-li {
          margin-right: 24px;
        }
      }
    }
  }

  .copyright {
    font-size: 12px;
    padding: 14px;
  }
}
.socialize
  display flex
  justify-content space-between
  padding-top 20px
  .socialize-item
    width 24px
    height 24px
    cursor pointer
</style>
